module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/efficiency',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.efficiency')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/operators_analysis',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.operators_analysis')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da9c8f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/OperatorsTab.vue
// module id = 522
// module chunks = 0